export const EARN_POINTS_COLORS = {
  "navigation-orange": {
    title: "text-nav-orange",
    bgBadge: "bg-nav-orange/20",
    textBadge: "text-nav-badge-orange",
  },
  "navigation-blue": {
    title: "text-nav-blue",
    bgBadge: "bg-nav-blue/20",
    textBadge: "text-nav-badge-blue",
  },
  "navigation-purple": {
    title: "text-nav-purple",
    bgBadge: "bg-nav-purple/20",
    textBadge: "text-nav-badge-purple",
  },
  "navigation-turquoise": {
    title: "text-nav-turquoise",
    bgBadge: "bg-nav-turquoise/20",
    textBadge: "text-nav-badge-turquoise",
  },
  "navigation-red": {
    title: "text-nav-red",
    bgBadge: "bg-nav-red/20",
    textBadge: "text-nav-badge-red",
  },
  "navigation-white": {
    title: "text-nav-white",
    bgBadge: "bg-nav-white/20",
    textBadge: "text-nav-badge-white",
  },
  "navigation-azure": {
    title: "text-nav-azure",
    bgBadge: "bg-nav-azure/20",
    textBadge: "text-nav-badge-azure",
  },
  "navigation-green": {
    title: "text-nav-green",
    bgBadge: "bg-nav-green/20",
    textBadge: "text-nav-badge-green",
  },
  "navigation-dark-fuchsia": {
    title: "text-nav-dark-fuchsia",
    bgBadge: "bg-nav-dark-fuchsia/20",
    textBadge: "text-nav-badge-dark-fuchsia",
  },
  "navigation-dark-blue": {
    title: "text-nav-dark-blue",
    bgBadge: "bg-nav-dark-blue/20",
    textBadge: "text-nav-badge-dark-blue",
  },
} as const;
